import { jsx as _jsx } from "react/jsx-runtime";
import { SearchHeadlessContext } from './SearchHeadlessContext';
export function SearchHeadlessProvider(props) {
    const { children, searcher } = props;
    return (_jsx(SearchHeadlessContext.Provider, Object.assign({ value: searcher }, { children: children }), void 0));
}
//# sourceMappingURL=SearchHeadlessProvider.js.map